angular.module("vgresiduos").directive("secondNavBar", function () {
	return {
		scope: true,
		replace: true,
		controller: "secondNavBarCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/components/secondNavBar/secondNavBar_template.html"
	};
});
